import {
  BLOG_DIFFERENTIATION_MORE_INFO,
  BLOG_DIFFERENTIATION_MORE_INFO_US,
} from 'global/public-routes.constants';

export function getDifferentiationBlogLink({
  isRegionAU,
}: {
  isRegionAU: boolean;
}) {
  return isRegionAU
    ? BLOG_DIFFERENTIATION_MORE_INFO
    : BLOG_DIFFERENTIATION_MORE_INFO_US;
}
